import React from "react";
import {InlineShareButtons} from 'sharethis-reactjs';
 
class SocialShare extends React.Component {
 
  render () {
    const { url } = this.props;
    return (
      <div>
        <InlineShareButtons
          config={{
            alignment: 'center',  
            color: 'social',      
            enabled: true,        
            font_size: 16,     
            labels: 'cta',    
            language: 'en',       
            networks: [      
              'whatsapp',
              'linkedin',
              'messenger',
              'facebook',
              // 'twitter'
            ],
            padding: 12,   
            radius: 4,        
            show_total: false,
            size: 40,   

            url: url, // (defaults to current url)
            image: 'https://bit.ly/2CMhCMC',  // (defaults to og:image or twitter:image)
            description: 'custom text',       // (defaults to og:description or twitter:description)
            title: 'custom title',            // (defaults to og:title or twitter:title)
            message: 'custom email text',     // (only for email sharing)
            subject: 'custom email subject',  // (only for email sharing)
            username: 'custom twitter handle' // (only for twitter sharing)
          }}
        />

      </div>
    );
  }
};
 
export default SocialShare;